// file-upload-widget.js
import {
  setupDragAndDrop,
  getFileExtension,
  getFileColorClass,
  showError,
  checkPrefilledValues
} from './file-widgets-common.js';

export function initializeFileWidget(widget) {
  const dropArea         = widget.find('.drop-area');
  const fileInput        = widget.find('input[type="file"]');
  const hiddenInput      = widget.find('input[type="hidden"]');
  const placeholder      = widget.find('.upload-placeholder');
  const previewContainer = widget.find('.preview-container');
  const fileIcon         = widget.find('.file-icon');
  const fileExtensionEl  = widget.find('.file-extension');
  const fileName         = widget.find('.file-name');
  const closeBtn         = widget.find('.btn-close-widget');

  // Общая настройка drag & drop
  setupDragAndDrop(dropArea, fileInput);

  // Показывает превью выбранного файла
  function showFilePreview(file) {
    const ext = getFileExtension(file.name);
    const cls = getFileColorClass(ext);

    fileIcon
      .removeClass(
        'text-danger text-primary text-success text-warning text-purple text-muted text-secondary'
      )
      .addClass(cls);

    fileExtensionEl
      .text(ext.toUpperCase());

    fileName
      .text(file.name)
      .attr('title', file.name);

    placeholder.hide();
    previewContainer.show();
  }

  // Сбрасывает виджет в начальное состояние
  function clearFileWidget() {
    fileInput.val('');
    hiddenInput.val('1');
    fileIcon.removeClass(
      'text-danger text-primary text-success text-warning text-purple text-muted text-secondary'
    );
    fileExtensionEl.text('');
    fileName.text('').attr('title', '');
    previewContainer.hide();
    placeholder.show();
    dropArea.removeClass('error');
  }

  // Клик по области: открываем диалог выбора файла
  dropArea.on('click', e => {
    if (!$(e.target).closest('.btn-close-widget').length) {
      fileInput.click();
    }
  });

  // При выборе файла через input или дроп
  fileInput.on('change', () => {
    const file = fileInput[0].files[0];
    if (file) {
      showFilePreview(file);
      hiddenInput.val('0');
    } else {
      showError(dropArea, 'Пожалуйста, выберите файл');
    }
  });

  // Клик по кнопке закрытия: сбрасываем виджет
  closeBtn.on('click', e => {
    e.stopPropagation();
    clearFileWidget();
  });

  // Обработка уже загруженных значений (prefill)
  checkPrefilledValues(widget);
}
